import React, { useEffect, useState } from "react";
import {
  FaUser,
  FaFileAlt,
  FaFlask,
  FaHospitalAlt,
  FaChevronDown,
  FaChevronRight,
  FaPlus,
  FaMinus,
  FaCircle,
  FaBullseye,
} from "react-icons/fa";
import { Routes, Route, Navigate, useNavigate } from "react-router-dom";

// User Management
import UserManament from "../usermanagment/UserManament";
import AddUserManagement from "../usermanagment/AddUserManagement";
import ViewUsermanagement from "../usermanagment/ViewUserManagement";

import HospitalSetting from "../hospitalsetting/HospitalSetting";
import AddHospital from "../hospitalsetting/AddorEditHospital";

// Call sub page
import RelatedDocument from "../manageWebsite/document/document"; // document
import ViewDocument from "../manageWebsite/document/ViewDocument";

// Lab
import LaboratoryInspectionGuideline from "../manageWebsite/lab/LaboratoryGuideline";
import AddLaboratory from "../manageWebsite/lab/AddLaboratoryGuideline";
import ViewLaboratory from "../manageWebsite/lab/ViewLaboratoryGuideline";

// Announcement
import Announcement from "../manageWebsite/announcement/Announcement";
import AddPressRelease from "../manageWebsite/announcement/AddAnnouncement";
import ViewAnnouncement from "../manageWebsite/announcement/ViewAnnouncement";

// Menu
import MenuManagement from "../manageWebsite/menu/Menu";
import AddMenuManagement from "../manageWebsite/menu/AddMenu";
import MenuList from "../manageWebsite/menu/MenuList";

//Contact
import Contact from "../manageWebsite/Contact/Contact";
import AddContact from "../manageWebsite/Contact/AddContact";
import ViewContact from "../manageWebsite/Contact/ViewContact";

// FAQ
import FAQ from "../manageWebsite/FAQ/FAQ";
import AddFAQ from "../manageWebsite/FAQ/AddFAQ";
import ViewFAQ from "../manageWebsite/FAQ/ViewFAQ";

// Question
import Questionnaire from "../manageWebsite/question/Questionnaire";
import AddQuestionnaire from "../manageWebsite/question/AddQuestionnair";
import ViewQuestionnaire from "../manageWebsite/question/ViewQuestionnair";
import DetailQuestionnaireQuestion from "../manageWebsite/question/DetailQuestionnaire";

// Banner
import BannerList from "../manageWebsite/banner/BannerList";
import AddBanner from "../manageWebsite/banner/AddBanner";
import ViewBanner from "../manageWebsite/banner/ViewBanner";

// Pharmacogenetics File
import Pharmacogenetics from "../manageWebsite/pharmacogeneticsFiles/pharmacogeneticsFiles";
import AddPharmacogenetics from "../manageWebsite/pharmacogeneticsFiles/addPharmacogeneticsFiles";
import ViewPharmacogenetics from "../manageWebsite/pharmacogeneticsFiles/viewPharmacogeneticsFiles";

// import LaboratoryInspectionGuideline from "../manageWebsite/LaboratoryInspectionGuideline";
import MenuAdmin from "../menu/Menu";
import ContactAdmin from "../contact/ContactAdmin";

import Petition from "../labinformation/Petition";
import Repeated from "../labinformation/Repeated";
import HistoryLog from "../historyLog/HistoryLog";

const Sidebar = ({ role, page, subsection, action, id }) => {
  const [isOpen, setIsOpen] = useState(true);
  const [submenuOpen, setSubmenuOpen] = useState(0);
  const [activeMenu, setActiveMenu] = useState(page);
  const [activeSubMenu, setActiveSubMenu] = useState(subsection);

  const navigate = useNavigate();

  useEffect(() => {}, [activeMenu, activeSubMenu]);

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
    if (isOpen) {
      setSubmenuOpen(0);
    }
  };

  const handleMenuClick = (menu) => {
    if (!isOpen) {
      setIsOpen(true);
    }

    if (menu !== "management" && menu !== "labinformation") {
      navigate(`/admin/${menu}`);
    }

    setActiveMenu(menu);
    toggleSubmenu(0);
  };

  const handleSubMenuClick = (submenu) => {
    setActiveSubMenu(submenu);
    navigate(`/admin/${activeMenu}/${submenu}`);
  };

  const toggleSubmenu = (name) => {
    setSubmenuOpen((prev) => (prev === name ? 0 : name));
  };

  const leafInnerStyle = (menuName) => ({
    justifyContent: isOpen ? "start" : "center",
    ...(activeMenu === menuName && {
      backgroundColor: "#00917E",
      color: "#fff",
      height: "42px",
      borderRadius: "6px",
    }),
  });

  const parentInnerStyle = (menuName) => ({
    justifyContent: isOpen ? "space-between" : "center",
    ...(activeMenu === menuName && {
      backgroundColor: "#DCF4E7",
      height: "42px",
      borderRadius: "6px",
    }),
  });

  const subItemStyle = (subName) => ({
    ...styles.submenuItem,
    ...(activeSubMenu === subName && styles.submenuItemActive),
  });

  const renderContent = () => {
    if (activeMenu === "management" || activeMenu === "labinformation") {
      if (activeSubMenu === "" || activeSubMenu == undefined) {
        if (activeMenu === "management") {
          handleSubMenuClick("document");
        }
        if (activeMenu === "labinformation") {
          handleSubMenuClick("patient");
        }
      }

      if (action === "view-document") {
        return <ViewDocument />;
      } else if (activeSubMenu === "document" || page === "document") {
        return <RelatedDocument />;
      }

      // Guideline
      if (action === "add-laboratory") {
        return <AddLaboratory />;
      } else if (action === "edit-laboratory") {
        return <AddLaboratory />;
      } else if (action === "view-laboratory") {
        return <ViewLaboratory />;
      } else if (
        activeSubMenu === "laboratory-inspection-guideline" ||
        page === "laboratory-inspection-guideline"
      ) {
        return <LaboratoryInspectionGuideline />;
      }

      // contact
      if (action === "add-contact") {
        return <AddContact />;
      } else if (action === "edit-contact") {
        return <AddContact />;
      } else if (action === "view-contact") {
        return <ViewContact />;
      } else if (activeSubMenu === "contact" || page === "contact") {
        return <Contact />;
      }

      // FAQ
      if (action === "add-faq") {
        return <AddFAQ />;
      } else if (action === "edit-faq") {
        return <AddFAQ />;
      } else if (action === "view-faq") {
        return <ViewFAQ />;
      } else if (activeSubMenu === "faq" || page === "faq") {
        return <FAQ />;
      }

      // content
      if (action === "add-pressrelease") {
        return <AddPressRelease />;
      } else if (action === "edit-pressrelease") {
        return <AddPressRelease />;
      } else if (action === "view-pressrelease") {
        return <ViewAnnouncement />;
      } else if (
        activeSubMenu === "press-release" ||
        page === "press-release"
      ) {
        return <Announcement />;
      }

      // Questionnaire
      if (action === "add-questionnaire") {
        return <AddQuestionnaire />;
      } else if (action === "edit-questionnaire") {
        return <AddQuestionnaire />;
      } else if (action === "view-questionnaire") {
        return <ViewQuestionnaire />;
      } else if (action === "detail-questionnaire") {
        return <DetailQuestionnaireQuestion />;
      } else if (
        activeSubMenu === "questionnaire" ||
        page === "questionnaire"
      ) {
        return <Questionnaire />;
      }

      // Banner
      if (action === "add-banner") {
        return <AddBanner />;
      } else if (action === "edit-banner") {
        return <AddBanner />;
      } else if (action === "view-banner") {
        return <ViewBanner />;
      }else if (
        activeSubMenu === "banner" ||
        page === "banner"
      ) {
        return <BannerList />;
      }

      // Pharmacogenetics
      if (action === "add-pharmacogenetics") {
        return <AddPharmacogenetics />;
      } else if (action === "edit-pharmacogenetics") {
        return <AddPharmacogenetics />;
      } else if (action === "view-pharmacogenetics") {
        return <ViewPharmacogenetics />;
      }else if (
        activeSubMenu === "pharmacogenetics" ||
        page === "pharmacogenetics"
      ) {
        return <Pharmacogenetics />;
      }

      if (action === "add-menu") {
        return <AddMenuManagement />;
      } else if (action === "edit-menu") {
        return <AddMenuManagement />;
      } else if (action === "menu-list") {
        return <MenuList />;
      } else if (activeSubMenu === "menu" || page === "menu") {
        return <MenuManagement />;
      }

      if (activeSubMenu === "patient" || page === "patient") {
        return <Petition />;
      } else if (activeSubMenu === "patients" || page === "patients") {
        return <Repeated />;
      }
    }

    // User Management
    if (
      activeSubMenu === "add-usermanagement" ||
      subsection === "add-usermanagement"
    ) {
      return <AddUserManagement />;
    }
    if (
      activeSubMenu === "edit-usermanagement" ||
      subsection === "edit-usermanagement"
    ) {
      return <AddUserManagement />;
    } else if (
      activeSubMenu === "view-usermanagement" ||
      subsection === "view-usermanagement"
    ) {
      return <ViewUsermanagement />;
    } else if (activeMenu === "usermanagement" || page === "usermanagement") {
      return <UserManament />;
    }

    if (activeMenu === "hospitalsetting" || page === "hospitalsetting") {
      if (subsection === "add-hospital") {
        return <AddHospital />;
      } else if (subsection === "edit-hospital") {
        return <AddHospital />;
      } else {
        return <HospitalSetting />;
      }
    }

    
    if (activeMenu === "historyLog" || page === "historyLog") {
 
        return <HistoryLog />
      
    }
    
  };

  return (
    <div style={styles.wrapper} className="mt-[30px]">
      <div
        style={{
          ...styles.sidebar,
          width: isOpen ? "263px" : "59px",
          minWidth: isOpen ? "263px" : "59px",
        }}
        onMouseEnter={() =>
          isOpen === false && window.innerWidth >= 768 && setIsOpen(true)
        }
        // onMouseLeave={() =>
        //   isOpen === true && window.innerWidth >= 768 && setIsOpen(false)
        // }
      >
        <div
          style={{
            ...styles.header,
            justifyContent: isOpen ? "space-between" : "center",
            padding: isOpen ? "0px 15px 0px 15px" : "",
          }}
        >
          {isOpen && <p style={styles.headerText}>สำหรับแอดมิน</p>}
          <button
            style={styles.toggleButton}
            onClick={toggleSidebar}
            aria-label={isOpen ? "Close Sidebar" : "Open Sidebar"}
          >
            {isOpen ? (
              <div className="flex justify-center items-center text-[30px] w-[40px] h-[40px]">
                -
              </div>
            ) : (
              <div className="flex justify-center items-center text-[30px] w-[40px] h-[40px]">
                +
              </div>
            )}
          </button>
        </div>
        <div style={styles.menu}>
          {/* menu 1 */}
          <div
            style={styles.menuItem}
            onClick={() => {
              handleMenuClick("usermanagement");
              toggleSubmenu(0);
              setActiveSubMenu("");
            }}
          >
            <div
              className="flex flex-row items-center gap-[10px] w-full pl-3 pr-3"
              style={leafInnerStyle("usermanagement")}
            >
              <FaUser style={{ width: "18px" }} />
              {isOpen && <span style={styles.text}>จัดการผู้ใช้งาน</span>}
            </div>
          </div>

          {/* menu 2 */}
          <div
            style={styles.menuItem}
            onClick={() => {
              setActiveMenu("management");
              toggleSubmenu(1);
            }}
          >
            <div
              className="w-full flex flex-row pl-3 pr-3 items-center"
              style={parentInnerStyle("management")}
            >
              <div className="flex flex-row items-center gap-[10px] flex-1">
                <FaFileAlt style={{ width: "18px" }} />
                {isOpen && <span style={styles.text}>จัดการเนื้อหา</span>}
              </div>
              {isOpen && (
                submenuOpen === 1
                  ? <FaChevronDown style={styles.chevron} />
                  : <FaChevronRight style={styles.chevron} />
              )}
            </div>
          </div>
          {submenuOpen === 1 && (
            <ul style={styles.submenu}>
              {[
                { key: "document",                       label: "เอกสารที่เกี่ยวข้อง" },
                { key: "laboratory-inspection-guideline", label: "แนวทางการตรวจ" },
                { key: "press-release",                  label: "ข่าวประกาศ" },
                { key: "menu",                           label: "เมนู" },
                { key: "contact",                        label: "ข้อมูลการติดต่อ" },
                { key: "faq",                            label: "คำถามที่พบบ่อย" },
                { key: "questionnaire",                  label: "แบบสำรวจความพึงพอใจ" },
                { key: "banner",                         label: "แบนเนอร์" },
                { key: "pharmacogenetics",               label: "แบบฟอร์มส่งตรวจ" },
              ].map(({ key, label }) => (
                <li
                  key={key}
                  style={subItemStyle(key)}
                  onClick={() => handleSubMenuClick(key)}
                >
                  <div className="flex flex-row items-center gap-[10px] w-full pl-6 pr-6">
                    <FaCircle style={{ width: "9px" }} />
                    {isOpen && <span style={styles.text}>{label}</span>}
                  </div>
                </li>
              ))}
            </ul>
          )}

          {/* menu 3 */}
          <div
            style={styles.menuItem}
            onClick={() => {
              setActiveMenu("labinformation");
              toggleSubmenu(2);
            }}
          >
            <div
              className="w-full flex flex-row pl-3 pr-3 items-center"
              style={parentInnerStyle("labinformation")}
            >
              <div className="flex flex-row items-center gap-[10px] flex-1">
                <FaFlask style={{ width: "18px" }} />
                {isOpen && <span style={styles.text}>กรองข้อมูลเเล็บ</span>}
              </div>
              {isOpen && (
                submenuOpen === 2
                  ? <FaChevronDown style={styles.chevron} />
                  : <FaChevronRight style={styles.chevron} />
              )}
            </div>
          </div>
          {submenuOpen === 2 && (
            <ul style={styles.submenu}>
              <li style={subItemStyle("patient")} onClick={() => handleSubMenuClick("patient")}>
                <div className="flex flex-row items-center gap-[10px] w-full pl-6 pr-6">
                  <FaCircle style={{ width: "9px" }} />
                  {isOpen && (
                    <span style={styles.text}>
                      รายชื่อผู้ป่วย
                      <br />
                      แจ้งตรวจสอบข้อมูล
                    </span>
                  )}
                </div>
              </li>
              <li style={subItemStyle("patients")} onClick={() => handleSubMenuClick("patients")}>
                <div className="flex flex-row items-center gap-[10px] w-full pl-6 pr-6">
                  <FaCircle style={{ width: "9px" }} />
                  {isOpen && <span style={styles.text}>รายชื่อผู้ที่มีการตรวจซ้ำ</span>}
                </div>
              </li>
            </ul>
          )}

          {/* menu 4 */}
          <div
            style={styles.menuItem}
            onClick={() => {
              handleMenuClick("hospitalsetting");
              toggleSubmenu(0);
              setActiveSubMenu("");
            }}
          >
            <div
              className="flex flex-row items-center gap-[10px] w-full pl-3 pr-3"
              style={leafInnerStyle("hospitalsetting")}
            >
              <FaHospitalAlt style={{ width: "18px" }} />
              {isOpen && <span style={styles.text}>ตั้งค่าโรงพยาบาล</span>}
            </div>
          </div>

          {/* menu 5 */}
          <div
            style={styles.menuItem}
            onClick={() => {
              handleMenuClick("historyLog");
              toggleSubmenu(0);
              setActiveSubMenu("");
            }}
          >
            <div
              className="flex flex-row items-center gap-[10px] w-full pl-3 pr-3"
              style={leafInnerStyle("historyLog")}
            >
              <FaBullseye style={{ width: "18px" }} />
              {isOpen && <span style={styles.text}>ประวัติเข้าใช้งาน</span>}
            </div>
          </div>
        </div>
      </div>

      <div style={styles.container}>{renderContent()}</div>
    </div>
  );
};

const styles = {
  wrapper: {
    display: "flex",
    height: "auto",
    width: "100%",
    backgroundColor: "#f4f4f4",
  },
  sidebar: {
    background: "#F5FFFA",
    color: "#00917E",
    transition: "width 0.3s",
    overflowX: "auto",
    display: "flex",
    flexDirection: "column",
    boxShadow: "2px 0 5px rgba(0, 0, 0, 0.1)",
  },
  container: {
    flex: 1,
    padding: "20px",
    overflow: "auto",
    backgroundColor: "white",
  },
  header: {
    display: "flex",
    alignItems: "center",
    height: "50px",
  },
  headerText: {
    fontSize: "16px",
    fontWeight: "600",
    color: "#00917E",
    lineHeight: "42px",
    fontFamily: "Prompt, sans-serif",
  },
  toggleButton: {
    background: "#F5FFFA",
    color: "#00917E",
    border: "1px solid #93D3B1",
    borderRadius: "6px",
    cursor: "pointer",
    padding: "2px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  menu: {
    display: "flex",
    flexDirection: "column",
    padding: "10px 0",
  },
  menuItem: {
    display: "flex",
    alignItems: "center",
    padding: "0 5px",
    justifyContent: "space-between",
    height: "50px",
    cursor: "pointer",
  },
  submenu: {
    borderLeft: "2px solid #93D3B1",
    listStyleType: "disc",
    color: "#00917E",
  },
  submenuItem: {
    display: "flex",
    alignItems: "center",
    padding: "5px 0",
    height: "50px",
    cursor: "pointer",
    transition: "background-color 0.3s",
    margin: "0px 5px",
  },
  submenuItemActive: {
    backgroundColor: "#00917E",
    color: "#fff",
    borderRadius: "6px",
  },
  text: {
    fontSize: "14px",
    fontWeight: "400",
    whiteSpace: "nowrap",
  },
};

export default Sidebar;
